import _ from 'lodash';

import { UPLOAD_ATTACHMENTS_SUCCESS } from './file-upload.actions';
import { normalizeAttachmentDataForOffline } from '../utils/actions/file-upload.offline.action.utils';
import { getDataPath, getEntityPrimaryKey } from '../utils/form-manager.utils';
import { generateRowId } from '../utils/runtime.utils';

export const ADD_OFFLINE_ATTACHMENT_SUCCESS = 'ADD_OFFLINE_ATTACHMENT_SUCCESS';

export function fileToArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('loadend', () => {
      resolve(reader.result);
    });
    reader.addEventListener('error', reject);
    reader.readAsArrayBuffer(file);
  });
}

export function saveAttachmentsForLocalDB(entityId, file, entityName, formKey, gridId, parentData) {
  return async (dispatch, getState) => {
    try {
      const fileArrayBuffer = await fileToArrayBuffer(file);
      const fileType = file.type;

      const { entityDefinition, data } = getState().formDesigner[formKey];
      const { formInfo } = data;
      const path = getDataPath(entityName, [0], entityDefinition);
      const allRows = _.get(data.entityDataStore?.entityData, path.slice(0, -1), []);
      const reversedRows = [...allRows].reverse();
      const rowId = generateRowId(reversedRows, 'BAH_ID');
      const entityType = Object.keys(entityDefinition)[0];
      const entityData = _.get(data, ['entityDataStore', 'entityData', entityType]);
      const primaryKeyColumn = getEntityPrimaryKey(entityDefinition, entityType);
      const PARENT_PK_ID = entityData[primaryKeyColumn];
      const result = normalizeAttachmentDataForOffline({
        fileName: file.name,
        PARENT_PK_ID,
        formInfo,
        rowId,
        gridId,
        parentData,
      });

      const fileObjectToSave = {
        fileType,
        fileName: file.name,
        entityName,
        rowId,
        PARENT_PK_ID,
        parentData,
        buffer: fileArrayBuffer,
      };

      dispatch({
        type: UPLOAD_ATTACHMENTS_SUCCESS,
        formKey,
        payload: {
          entityName,
          result,
        },
      });

      dispatch({
        type: ADD_OFFLINE_ATTACHMENT_SUCCESS,
        payload: {
          id: entityId,
          attachmentData: fileObjectToSave,
        },
      });
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
